import { lazy, number } from 'yup'
import { cssLengthUnitSchema } from './cssLengthUnitSchema'

export const spacingSchema = lazy((value) => {
  if (typeof value === 'number') {
    return number().oneOf([0])
  }
  return cssLengthUnitSchema
})
